module.exports = __webpack_public_path__ + "media/customizations/windsong/back-7c7d354e40f78e90441d1bf9e6ed808a.jpg";